import Sidebar from "../../Components/Sidebar";
import Button from "@mui/material/Button";
import { IoIosMenu } from "react-icons/io";
import { CgMenuGridR } from "react-icons/cg";
import { HiViewGrid } from "react-icons/hi";
import { TfiLayoutGrid4Alt } from "react-icons/tfi";
import { FaAngleDown } from "react-icons/fa6";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useContext, useEffect, useState } from "react";
import ProductItem from "../../Components/ProductItem";
import NoProductsFound from "../../Components/NoProductsFound";

import { useNavigate, useParams } from "react-router-dom";
import { fetchDataFromApi } from "../../utils/api";
import CircularProgress from "@mui/material/CircularProgress";
import { FaFilter } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import { MyContext } from "../../App";

const Listing = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [productView, setProductView] = useState("four");
  const [productData, setProductData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [filterId, setFilterId] = useState("");
  const [catName, setCatName] = useState("SabbaFarm");
  const [subCatName, setSubCatName] = useState("SabbaFarm");

  const [page, setPage] = useState(10);

  const history = useNavigate();

  const { id } = useParams();

  const openDropdown = Boolean(anchorEl);

  const context = useContext(MyContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    setFilterId("");

    let url = window.location.href;
    let apiEndPoint = "";

    if (url.includes("subCat")) {
      apiEndPoint = `/api/products/subCatId?subCatId=${id}`;
    }
    if (url.includes("category")) {
      apiEndPoint = `/api/products/catId/${id}`;
    }

    setisLoading(true);
    fetchDataFromApi(`${apiEndPoint}`).then((res) => {
      setProductData(res);
      setSubCatName(
        res?.products?.[0]?.subCatName ||
          "Stay Tuned for the Products, Stock will be Filled Soon"
      );
      setCatName(
        res?.products?.[0]?.catName ||
          "Stay Tuned for the Products, Stock will be Filled Soon"
      );
      setisLoading(false);
    });

    context.setEnableFilterTab(true);
  }, [id]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (val) => {
    if (val !== "" && val !== undefined && val !== null) {
      setPage(val);
      setAnchorEl(null);

      let url = window.location.href;
      let apiEndPoint = "";

      if (url.includes("subCat")) {
        apiEndPoint = `/api/products/subCatId?subCatId=${id}&page=1&perPage=${val}`;
      }
      if (url.includes("category")) {
        apiEndPoint = `/api/products/catId/${id}?page=1&perPage=${val}`;
      }

      setisLoading(true);
      fetchDataFromApi(`${apiEndPoint}`).then((res) => {
        setProductData(res);
        setisLoading(false);
      });
    }
  };

  const handleChangePage = (event, value) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    let url = window.location.href;
    let apiEndPoint = "";
    if (url.includes("subCat")) {
      apiEndPoint = `/api/products/subCatId?subCatId=${id}&page=${value}&perPage=8`;
    }
    if (url.includes("category")) {
      apiEndPoint = `/api/products/catId/${id}?page=${value}&perPage=8`;
    }

    setisLoading(true);
    fetchDataFromApi(`${apiEndPoint}`).then((res) => {
      setProductData(res);
      setisLoading(false);
    });
  };

  const filterData = (subCatId) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    //setFilterId(subCatId);
    //setisLoading(true);

    // fetchDataFromApi(
    //   `/api/products/subCatId?subCatId=${subCatId}&location=${localStorage.getItem(
    //     "location"
    //   )}`
    // ).then((res) => {
    //   setProductData(res);
    //   setisLoading(false);
    // });

    history(`/products/subCat/${subCatId}`);
  };

  const filterByPrice = (price, subCatId) => {
    var window_url = window.location.href;
    var api_EndPoint = "";

    if (window_url.includes("subCat")) {
      api_EndPoint = `/api/products/filterByPrice?minPrice=${price[0]}&maxPrice=${price[1]}&subCatId=${id}`;
    }
    if (window_url.includes("category")) {
      api_EndPoint = `/api/products/filterByPrice?minPrice=${price[0]}&maxPrice=${price[1]}&catId=${id}`;
    }

    setisLoading(true);

    fetchDataFromApi(api_EndPoint).then((res) => {
      setProductData(res);
      setisLoading(false);
    });
  };

  const filterByRating = (rating, subCatId) => {
    setisLoading(true);
    let url = window.location.href;
    let apiEndPoint = "";

    if (url.includes("subCat")) {
      apiEndPoint = `/api/products/rating?rating=${rating}&subCatId=${id}`;
    }
    if (url.includes("category")) {
      apiEndPoint = `/api/products/rating?rating=${rating}&catId=${id}`;
    }

    fetchDataFromApi(apiEndPoint).then((res) => {
      setProductData(res);
      setisLoading(false);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  };

  const handleChange = (event, value) => {
    setisLoading(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchDataFromApi(
      `/api/products?subCatId=${id}&page=${value}&perPage=6`
    ).then((res) => {
      setProductData(res);
      setisLoading(false);
    });
  };
  const isCategory = id.includes("category");
  const isSubCategory = id.includes("subCat");

  const categoryName = isCategory ? id.replace("category-", "") : ""; // Extract category name
  const subCategoryName = isSubCategory ? id.replace("subCat-", "") : ""; // Extract subcategory name

  return (
    <>
      {window.location.href.includes("category") ? (
        <div className="bg-gradient-to-tr from-[#298e4d]  to-[#fa9527] h-[120px] pt-0 md:h-[160px] w-full flex items-center justify-center px-4">
          <h1 className="text-2xl md:text-4xl font-bold text-white text-center capitalize">
            {catName}
          </h1>
        </div>
      ) : window.location.href.includes("subCat") ? (
        <div className="bg-gradient-to-tr from-[#298e4d]  to-[#fa9527] h-[120px] pt-0 md:h-[160px] w-full flex items-center justify-center px-4">
          <h1 className="text-2xl md:text-4xl font-bold text-white text-center capitalize">
            {subCatName}
          </h1>
        </div>
      ) : (
        "SabbaFarm"
      )}
      <Helmet>
        {/* Dynamic Page Title */}
        <title>
          {isCategory
            ? `Browse ${categoryName} Products - SabbaFarm (Sabba Farm)`
            : isSubCategory
            ? `Browse ${subCategoryName} Products - SabbaFarm (Sabba Farm)`
            : "Browse Products - SabbaFarm (Sabba Farm)"}
        </title>

        <meta
          name="description"
          content={
            isCategory
              ? `Explore a wide range of ${categoryName} products on SabbaFarm (Sabba Farm). Find the best deals and quality products across the ${categoryName} category.`
              : isSubCategory
              ? `Explore a wide range of ${subCategoryName} products on SabbaFarm (Sabba Farm). Find the best deals and quality products across the ${subCategoryName} subcategory.`
              : "Browse through a variety of products on SabbaFarm (Sabba Farm). Find the best deals and quality products across different categories and subcategories."
          }
        />

        {/* Meta Keywords */}
        <meta
          name="keywords"
          content={
            isCategory
              ? `${categoryName}, buy ${categoryName} online, best ${categoryName} products, SabbaFarm ${categoryName}, farm fresh ${categoryName}`
              : isSubCategory
              ? `${subCategoryName}, buy ${subCategoryName} online, best ${subCategoryName} products, SabbaFarm ${subCategoryName}`
              : "SabbaFarm products, buy online, farm fresh, quality products, best deals"
          }
        />

        {/* Robots Tag */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content={
            isCategory
              ? `Shop ${categoryName} - SabbaFarm`
              : isSubCategory
              ? `Shop ${subCategoryName} - SabbaFarm`
              : "Shop Online - SabbaFarm"
          }
        />
        <meta
          property="og:description"
          content={
            isCategory
              ? `Shop fresh and affordable ${categoryName} at SabbaFarm. Trusted for quality and variety.`
              : isSubCategory
              ? `Browse premium ${subCategoryName} options at SabbaFarm. Your go-to place for fresh and reliable products.`
              : "Discover top-quality products at SabbaFarm. Shop categories and subcategories for great deals."
          }
        />
        <meta
          property="og:url"
          content={`https://sabbafarm.com/products/${
            isCategory
              ? `category/${categoryName}`
              : isSubCategory
              ? `subCat/${subCategoryName}`
              : "all"
          }`}
        />
        <meta property="og:type" content="website" />

        {/* Canonical URL for SEO */}
        <link
          rel="canonical"
          href={`https://sabbafarm.com/products/${
            isCategory
              ? `category/${categoryName}`
              : isSubCategory
              ? `subCat/${subCategoryName}`
              : "all"
          }`}
        />
      </Helmet>

      <section className="product_Listing_Page pt-5">
        <div className="container">
          <div className="productListing d-flex">
            <Sidebar
              filterData={filterData}
              filterByPrice={filterByPrice}
              filterByRating={filterByRating}
              isOpenFilter={context?.isOpenFilters}
            />

            <div className="content_right">
              <div className="showBy mt-0 mb-3 d-flex align-items-center">
                <div className="d-flex align-items-center btnWrapper">
                  <Button
                    className={productView === "one" && "act"}
                    onClick={() => setProductView("one")}
                  >
                    <IoIosMenu />
                  </Button>

                  <Button
                    className={productView === "three" && "act"}
                    onClick={() => setProductView("three")}
                  >
                    <CgMenuGridR />
                  </Button>
                  <Button
                    className={productView === "four" && "act"}
                    onClick={() => setProductView("four")}
                  >
                    <TfiLayoutGrid4Alt />
                  </Button>
                </div>

                <div className="ml-auto showByFilter">
                  <Button onClick={handleClick}>
                    Show {page} <FaAngleDown />
                  </Button>
                  <Menu
                    className="w-100 showPerPageDropdown"
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={openDropdown}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={() => handleClose(10)}>10</MenuItem>
                    <MenuItem onClick={() => handleClose(20)}>20</MenuItem>
                    <MenuItem onClick={() => handleClose(30)}>30</MenuItem>
                    <MenuItem onClick={() => handleClose(40)}>40</MenuItem>
                    <MenuItem onClick={() => handleClose(50)}>50</MenuItem>
                    <MenuItem onClick={() => handleClose(60)}>60</MenuItem>
                  </Menu>
                </div>
              </div>

              <div className="productListing">
                {isLoading === true ? (
                  <div className="loading d-flex align-items-center justify-content-center">
                    <CircularProgress color="inherit" />
                  </div>
                ) : (
                  <>
                    {(() => {
                      const items =
                        productData?.data || productData?.products || [];
                      if (!items.length) {
                        return <NoProductsFound />;
                      }
                      return items.map((item, index) => (
                        <ProductItem
                          key={index}
                          itemView={productView}
                          item={item}
                        />
                      ));
                    })()}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Listing;
